import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCatBlog, updateCatBlog, deleteCatBlog, createCatBlog } from '../../redux/reducers/blogSlice'; // Certifique-se de importar corretamente
import Loader from '../../components/loading';
import PaginationComponent from '../../components/paginacao';


const CatBlog = () => {

    const [selectedCatBlog, setSelectedCatBlog] = useState(null);
    const [deleteCatPostId, setDeleteCatPostId] = useState(null);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [showAlert, setAlert] = useState(false);

    const [formState, setFormState] = useState({
        name: '',
    });
    const initialFormState = {
        name: '',
    };

    const [formStateEdit, setFormStateEdit] = useState(initialFormState);
    const dispatch = useDispatch();
    const { cats, loading2, error, message2 } = useSelector((state) => state.blog);
    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;
    const totalPages = Math.ceil(cats?.total / itemsPerPage);

    const handleFormChange = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.value,
        });
    };

    const handleFormChangeEdit = (e) => {
        setFormStateEdit({
            ...formStateEdit,
            [e.target.name]: e.target.value,
        });
        setShowModalEdit(true)
    };
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handleDeleteChange = (cat) => {
        setDeleteCatPostId(cat.id);
        setShowModalDelete(true);
    };
    const handleDelete = async () => {
        await dispatch(deleteCatBlog(deleteCatPostId));
        setShowModalDelete(false);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        await dispatch(createCatBlog(formState));
        setFormState({ name: '' });
        setShowModalAdd(false);
        setAlert(true)
    };


    const handleSubmitEdit = async (e) => {
        e.preventDefault();
        await dispatch(updateCatBlog({ id: selectedCatBlog, data: formStateEdit }));
        setFormStateEdit(initialFormState);
        setShowModalEdit(false);
        setAlert(true)
    };
    const handleEdit = (cat) => {
        console.log(cat, 'cat')
        setFormStateEdit({ name: cat.name });

        setSelectedCatBlog(cat.id);
        setShowModalEdit(true);
    };
    useEffect(() => {
        dispatch(fetchCatBlog(currentPage));
    }, [dispatch, currentPage]);

    return (
        <Container>
            {message2 && (
                <Alert className="text-center" variant="success" show={showAlert}>
                    {message2}
                    <Button className="m-3" variant="close" onClick={() => setAlert(false)} />
                </Alert>
            )}
            <div className='d-flex justify-content-center'>
                <PaginationComponent
                    currentPage={currentPage}
                    lastPage={totalPages}
                    onPageChange={handlePageChange}
                />
            </div>
            <div className={`loading ${loading2 ? 'loading-active' : ''}`}>
                <div className="d-flex justify-content-end mb-3">
                    <Button variant="primary" className='botao-acao' onClick={() => setShowModalAdd(true)}>
                        Adicionar Categoria
                    </Button>
                </div>
                <Loader loading={loading2} />
                <Table hover responsive className='text-center tabela-painel mt-4' style={{ fontSize: '0.7em' }}>
                    <thead>
                        <tr className='cabecalho-tabela'>
                            <th>Nome</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cats?.data?.map((cat) => (
                            <tr key={cat.id} className='celula-tabela'>
                                <td>{cat.name}</td>
                                <td>
                                    <Button
                                        variant="warning"
                                        size="sm"
                                        className="me-2 botao-acao"
                                        onClick={() => handleEdit(cat)}
                                    >
                                        Editar
                                    </Button>
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        className="me-2 botao-acao"
                                        onClick={() => handleDeleteChange(cat)}
                                    >
                                        Excluir
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            <Modal show={showModalDelete} onHide={() => setShowModalDelete(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Excluir Categoria</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className='text-center mb-3'>Tem certeza de que deseja excluir esta categoria?</p>
                    <div className='d-flex justify-content-center mt-3'>
                        <Button className="text-center" variant="danger" onClick={handleDelete} >
                            Excluir
                        </Button>
                        <Button className="text-center" variant="secondary" onClick={() => setShowModalDelete(false)} style={{ marginLeft: '15px' }}>
                            Cancelar
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            {/*cadastro do post*/}
            <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Adicionar Categoria</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Form.Group as={Col} md="6">
                                <Form.Label>Nome:</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    valueS={formState.name}
                                    onChange={handleFormChange}
                                    required
                                />
                            </Form.Group>
                        </Row>
                        <Button type="submit" disabled={loading2} className="mt-4">
                            {loading2 ? 'Salvando...' : 'Salvar'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
            {/*Edicao*/}
            <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Editar Categoria</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmitEdit}>
                        <Row>
                            <Form.Group as={Col} md="6">
                                <Form.Label>Título:</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formStateEdit.name}
                                    onChange={handleFormChangeEdit}
                                    required
                                />
                            </Form.Group>
                        </Row>
                        <Button type="submit" disabled={loading2} className="mt-4">
                            {loading2 ? 'Salvando...' : 'Salvar'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

        </Container>
    );
};

export default CatBlog;
